
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 5a1 1 0 01.993.883L13 6v5.5h5.5a1 1 0 01.117 1.993l-.117.007H13V19a1 1 0 01-1.993.117L11 19v-5.5H5.5a1 1 0 01-.117-1.993L5.5 11.5H11V6a1 1 0 011-1z","fill":"#5FB8EE","fill-rule":"nonzero"}})])
          )
        }
      }
    